var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOnboardingMessengerTheme(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icOnboardingMessengerTheme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "What\\u2019s-new-in-messenger-popup",
    transform: "translate(-408.000000, -421.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(368.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(25.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icOnboardingMessengerTheme",
    transform: "translate(16.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C11.2077279,0 0,11.2342474 0,25.0591532 C0,37.9957531 9.80272351,48.6655696 22.3730464,49.9812629 C24.4924963,50.203099 26.2499987,48.4227264 26.2499987,46.3594334 L26.2499987,36.3357721 C26.2499987,35.6289436 26.7948387,35.0828145 27.5,35.0828145 L43.7499978,35.0828145 C46.1798452,35.0828145 48.6169276,33.5154722 49.2431625,31.0253842 C49.7321875,29.0808541 49.98662,27.082557 50,25.0689413 C50,25.0672707 50,25.0656001 50,25.0639295 C50,25.0623374 50,25.0607453 50,25.0591532 C50,11.2342474 38.7922681,0 25,0 Z",
    id: "path16783",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3469388,10.2040816 C19.5850405,10.2040816 21.4285714,12.0476125 21.4285714,14.2857143 C21.4285714,16.5238161 19.5850405,18.3673469 17.3469388,18.3673469 C15.108837,18.3673469 13.2653061,16.5238161 13.2653061,14.2857143 C13.2653061,12.0476125 15.108837,10.2040816 17.3469388,10.2040816 Z",
    id: "path16783-path",
    fill: "#FF6EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6530612,10.2040816 C34.8911619,10.2040816 36.7346939,12.0476125 36.7346939,14.2857143 C36.7346939,16.5238161 34.8911619,18.3673469 32.6530612,18.3673469 C30.4149605,18.3673469 28.5714286,16.5238161 28.5714286,14.2857143 C28.5714286,12.0476125 30.4149605,10.2040816 32.6530612,10.2040816 Z",
    id: "path16783-path",
    fill: "#9932CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2244898,19.3877551 C13.4625916,19.3877551 15.3061224,21.2312871 15.3061224,23.4693878 C15.3061224,25.7074884 13.4625916,27.5510204 11.2244898,27.5510204 C8.98638803,27.5510204 7.14285714,25.7074884 7.14285714,23.4693878 C7.14285714,21.2312871 8.98638803,19.3877551 11.2244898,19.3877551 Z",
    id: "path16783-path",
    fill: "#7ACB45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7755102,19.3877551 C41.0136109,19.3877551 42.8571429,21.2312871 42.8571429,23.4693878 C42.8571429,25.7074884 41.0136109,27.5510204 38.7755102,27.5510204 C36.5374095,27.5510204 34.6938776,25.7074884 34.6938776,23.4693878 C34.6938776,21.2312871 36.5374095,19.3877551 38.7755102,19.3877551 Z",
    id: "path16783-path",
    fill: "#007FFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnboardingMessengerTheme);
export default __webpack_public_path__ + "static/media/icOnboardingMessengerTheme.1a64e53459421a35b3e01c96c5bcce35.svg";
export { ForwardRef as ReactComponent };